import type { PaymentCard } from '@/services/billing/types';

const BRAND_LABELS = new Map([
  ['visa', 'Visa'],
  ['mastercard', 'Mastercard'],
  ['amex', 'American Express'],
  ['discover', 'Discover'],
]);

export function cardLabel(card: PaymentCard | null): string {
  if (card == null) return 'Card on file';
  return `${BRAND_LABELS.get(card.brand) ?? 'Card'} ending in ${card.last4}`;
}

export type CardEntry = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
};
